/* eslint-disable max-classes-per-file */

import { makeAutoObservable } from 'mobx';
import {
    alias,
    getDefaultModelSchema,
    identifier,
    list,
    object,
    primitive,
    serializable,
    serialize,
    update,
} from 'serializr';

// eslint-disable-next-line import/no-cycle
import User from './User';

export class CourtType {
    @serializable hard!: number;
    @serializable clay!: number;
    @serializable grass!: number;

    constructor() {
        makeAutoObservable(this);
    }

    fromJSON(json: any) {
        update<CourtType>(this, json);
        return this;
    }

    toJSON() {
        return serialize<CourtType>(this);
    }
}

class Calendar {
    @serializable date!: string;
    @serializable(list(primitive())) time!: string[];

    constructor() {
        makeAutoObservable(this);
    }

    fromJSON(json: any) {
        update<Calendar>(this, json);
        return this;
    }

    toJSON() {
        return serialize<Calendar>(this);
    }
}

export default class Court {
    @serializable(alias('_id', identifier())) id!: string;
    @serializable name!: string;
    @serializable(object(CourtType)) type!: CourtType;
    @serializable country!: string;
    @serializable region!: string;
    @serializable city!: string;
    @serializable address!: string;
    @serializable phones!: string;
    @serializable website!: string;
    @serializable image!: string;
    @serializable totalPlayers!: number;
    @serializable totalCoaches!: number;
    players: User[] = []; // TODO: @serializable(list(object(User))
    @serializable status!: string;

    @serializable(list(object(Calendar))) calendar: Calendar[] = [];

    @serializable verified!: boolean;
    @serializable managed!: boolean;

    @serializable visitedAt!: string;

    get lastSeen() {
        return '';
    }

    constructor() {
        const schema = getDefaultModelSchema<this>(Court);
        if (schema) {
            schema.props.players = list(object(User));
        }

        makeAutoObservable(this);
    }

    fromJSON(json: any) {
        update<Court>(this, json);
        return this;
    }

    toJSON() {
        return serialize<Court>(this);
    }
}
